export default "__VITE_ASSET__BiduWrsJ__"